import { CategoricalBarChartValueAxisProps } from '../types/categorical-bar-chart.js';

/**
 * Value axis slot component.
 */
export const ValueAxis = (props: CategoricalBarChartValueAxisProps) => null;

ValueAxis['displayName'] = 'CategoricalBarChart.ValueAxis';
